import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useAppStore } from '@store'
import { ReactMouseEvent } from '@types'
import { LinkedItemsActions } from '../../../store/linkedItemsActions'
type Props = {
  e: ReactMouseEvent
  ctx: Omit<ReturnType<typeof useLinkedContext>, 'actions'>
  canPaste: string
  editLinkedTexture: LinkedItemsActions['editLinkedTexture']
  zoneInfo: { zoneName: string; zone: string }
}
export async function handlePaste({ e, canPaste, ctx, editLinkedTexture, zoneInfo }: Props) {
  if (e && e.preventDefault) {
    e.preventDefault()
    e.stopPropagation()
  }

  if (canPaste === 'cantPaste') return
  const [id, zone] = ctx.highlighted.split('!') // Selected element id
  if (!id || !zone)
    return console.error('Gets out on handling paste: no id or zone found', {
      highlighted: ctx.highlighted,
      id,
      zone,
    })
  const item = useAppStore.getState().items.get(id)
  const material = item.zones[zone].material

  editLinkedTexture(id, zoneInfo.zoneName, material)
  ctx.setPasteIcons((prev) => {
    const newPaste = { ...prev, [zoneInfo.zone]: 'cantPaste' }
    if (Object.values(newPaste).every((el) => el === 'cantPaste')) {
      ctx.setCopiedIconId('')
    }
    return newPaste
  })

  return
}
